import { useTranslation } from 'react-i18next';
import { buildPrice } from '@pages/checkout/helper';
import { Price, Discount } from '@global/types/types';

interface PriceProps {
  price: Price;
  discount?: Discount;
  priceBeforeDiscount?: number;
}

export const ItemPrice = ({
  price,
  priceBeforeDiscount,
  discount,
}: PriceProps) => {
  const { t } = useTranslation();
  const withDiscount = priceBeforeDiscount > price.value;

  return (
    <div className="order-item__price">
      {withDiscount && (
        <div className="order-item__price-discount">
          {`${price.code}${priceBeforeDiscount.toFixed(2)}`}
        </div>
      )}
      <div>{withDiscount ? price.value.toFixed(2) : buildPrice(price)}</div>
      {discount && (
        <div className="order-item__price-discount-label">
          <div>
            {discount.freeTrialDuration
              ? discount.discount // already formatted and translated in getDiscount
              : t('checkout.review.productInfo.discountInfo', {
                  discount: discount.discount,
                })}
          </div>
          <div>{discount.title}</div>
        </div>
      )}
    </div>
  );
};
